export default "__VITE_ASSET__BqH_xTLh__"